import { Component, Input,ElementRef, Renderer2, Inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NotificationsModalComponent } from '../modals/notifications-modal/notifications-modal.component';
import { notificationsModalParams } from '../../constants/notifications-modal-params';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { SearchService } from 'src/app/shared/services/search.service';
import { Notification } from '../../interfaces/notification'; 
import { LocalizationService } from '../../services/localization.service';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-header-actions',
  templateUrl: './header-actions.component.html',
  styleUrls: ['./header-actions.component.scss', './header-actions.component.en.scss']
})
export class HeaderActionsComponent {
  generalSettingsData: any;

  @Input() set generalSettings(value:any){
    if(value){
      this.generalSettingsData = value;
      this.getNotificationSettings();
    }
  }

  LocalizationService = LocalizationService;

  constructor(
    private element: ElementRef,
    private dialog: MatDialog,
    private searchService: SearchService,
    public localizationService: LocalizationService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) {}
  countOfUnreadNotifications: number = 0;
  portalNotificationSettings: any = {};
  
  getNotificationSettings() {
    if(this.generalSettingsData.portalGeneralSettingsData)
    {
      this.portalNotificationSettings.title = this.generalSettingsData.portalGeneralSettingsData.popupTitle;
      this.portalNotificationSettings.size = this.generalSettingsData.portalGeneralSettingsData.popupSize;
      this.portalNotificationSettings.minuteFormat = this.generalSettingsData.portalGeneralSettingsData.notificationsTimeDescriptionInMinutesText;
      this.portalNotificationSettings.hourFormat = this.generalSettingsData.portalGeneralSettingsData.notificationsTimeDescriptionInHoursText;
      this.portalNotificationSettings.dayFormat = this.generalSettingsData.portalGeneralSettingsData.notificationsTimeDescriptionInDaysText;
      this.portalNotificationSettings.noResult = this.generalSettingsData.portalGeneralSettingsData.noResult;
      this.portalNotificationSettings.readMoreBtnText = this.generalSettingsData.portalGeneralSettingsData.readMoreBtnText;
      this.portalNotificationSettings.readLessBtnText = this.generalSettingsData.portalGeneralSettingsData.readLessBtnText;
    }
    if(this.generalSettingsData.notifications) {
      this.countOfUnreadNotifications = this.generalSettingsData.notifications.totalUnreadCount;
    }
  }

  openNotifications() { 
    if(this.dialog.openDialogs.length > 0) return;

    disableBodyScroll(this.element.nativeElement);

    const notificationsData = {
      notificationSettings: this.portalNotificationSettings,
      notifications: this.generalSettingsData.notifications
    }

    const dialogRef = this.dialog.open(NotificationsModalComponent,
      {
        ...notificationsModalParams,
        data: notificationsData
      }
    );

    if(document.dir != 'rtl') {
      setTimeout(() => {
        let dialogElem = this.document.getElementById(dialogRef.id);
        let parent = dialogElem?.closest(".cdk-global-overlay-wrapper");
        if(parent) {
          this.renderer.setStyle(parent, 'justify-content', 'flex-end');
        }
      }, 0);
    }
    

    dialogRef.afterClosed().subscribe(() => {
      enableBodyScroll(this.element.nativeElement);
      this.disableReadNotifications();
    });
  }

  disableReadNotifications() {
    const readNotifications = this.generalSettingsData.notifications 
      ? (this.generalSettingsData.notifications.notificationItems as Notification[]).filter(x => x.readOnFront) : [];
    this.countOfUnreadNotifications -= readNotifications.length;
    readNotifications.forEach(element => {
      element.disabled = true;
      element.readOnFront = false;
    }); 
  }

  openSearch() {
    this.searchService.setOpen(true);
  }

  setCurrentCultureCode(cultureCode: string) {
    this.localizationService.setCurrentCultureCode(cultureCode);
  }
}
